<template>
  <div class="left-menu-main-div">
    <div v-for="item in this.menuList" :class="item.selected ? 'select-item-bg' : 'normal-item-bg'" @click="menuItemClick(item)">
      <p :class="item.selected ? 'select-item-title' : 'normal-item-title'">{{item.title}}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LeftMenu',
  data () {
    return {
      menuList: []
    }
  },
  methods: {
    setMenuList (list) {
      this.menuList = list
    },
    menuItemClick (item) {
      this.clearAllSelected()
      item.selected = true
      this.$emit('menuItemClick', item)
    },
    clearAllSelected () {
      for (let i = 0; i < this.menuList.length; i++) {
        let item = this.menuList[i]
        item.selected = false
      }
    }
  }
}
</script>

<style scoped>
  .left-menu-main-div{
    background-color: #FFFFFF;
    text-align: center;
  }
  .select-item-bg{
    background-color: rgba(92,182,176,0.40);
    cursor: pointer;
  }
  .normal-item-bg{
    background-color: #FFFFFF;
    cursor: pointer;
  }
  .select-item-title{
    font-family: PingFangSC-Regular;
    font-size: 20px;
    color: #FFFFFF;
    letter-spacing: 0;
    height: 40px;
    margin-bottom: 10px;
    padding-top: 16px;
  }
  .normal-item-title{
    font-family: PingFangSC-Regular;
    font-size: 20px;
    color: #6FBEB8;
    letter-spacing: 0;
    height: 40px;
    margin-bottom: 10px;
    padding-top: 16px;
  }
</style>



// WEBPACK FOOTER //
// src/components/live/LeftMenu.vue